export const FOOTER_HEIGHT = 34;
export const FOOTER_HEIGHT_PX = '34px';
export const APP_BAR_HEIGHT = 64;
export const APP_BAR_HEIGHT_PX = '64px';
export const MENU_DRAWER_WIDTH = '214px';
export const MENU_MINI_DRAWER_WIDTH = '58px';
export const CONVERSATION_DRAWER_WIDTH = '320px';
export const CONVERSATION_MINI_DRAWER_WIDTH = '42px';
export const DOCUMENT_DRAWER_WIDTH = '460px';
export const DOCUMENT_MINI_DRAWER_WIDTH = '42px';